import React from 'react';
const rows = [{
  tag: 'SND',
  name: 'Sound',
  color: 'bg-coral'
}, {
  tag: 'WRD',
  name: 'Word',
  color: 'bg-sage'
}, {
  tag: 'SEN',
  name: 'Sentence',
  color: 'bg-smoke'
}, {
  tag: 'SOC',
  name: 'Social',
  color: 'bg-gold'
}];
const coverage = [{
  label: 'Every theme',
  body: 'A shared scene, a short story and an 8-word picture strip, so pre-readers are in the same game'
}, {
  label: 'Every grid',
  body: '12 ready targets — 4 rows × Start, Build and Stretch — with a data strip at the bottom'
}, {
  label: 'Sound row',
  body: 'Theme words for the 9 most-targeted sound groups, by position, moving from words to conversation across the year'
}, {
  label: 'Every week',
  body: 'Two 30-minute sessions per theme: setup, a short script, cues, rotation and the common error to watch for'
}, {
  label: 'Fluency & AAC',
  body: 'A box on how students with fluency or AAC goals join each row of the same session'
}, {
  label: 'Format',
  body: 'Landscape pages that work in black and white — use them on screen or print once, nothing to cut or laminate'
}];
const steps = ['Open the theme', 'Place each student', 'Run the session', 'Mark the data strip'];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-plum-mid" data-id="element-235" data-mp="1oscflsfnrarf">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-236" data-mp="s2lf9ckoqtdp">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-237" data-mp="w3osdrbcmbb8">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-white text-3xl sm:text-5xl" data-id="element-238" data-mp="1128bzl2gzb0f">
          The Stacked Session Method
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-239" data-mp="2chx1ok73yo4x">
          One theme and one shared activity for the whole group. On that same
          page sit four goal rows, each at three levels. You mark the row and
          level for each student, and everyone works the same page at the same
          time.{' '}
          <span className="font-semibold text-white" data-id="element-240" data-mp="1msreunazkar9">
            One theme, one page, every goal in the group.
          </span>
        </p>

        <div className="mx-auto mt-8 grid max-w-md gap-1.5" aria-label="The 4-Row Stack: Sound, Word, Sentence and Social" data-id="element-241" data-mp="21oz4421942de">
          {rows.map(row => <div key={row.tag} className="grid grid-cols-[84px_1fr_1fr_1fr] items-center gap-1.5 text-left sm:grid-cols-[112px_1fr_1fr_1fr]" data-id="element-242" data-mp="192nvq57ekx61">
              <span className={`truncate rounded-lg px-2 py-2 text-[11px] font-bold uppercase tracking-wide text-plum-deep ${row.color}`} data-id="element-243" data-mp="1itqxl985pg6d">
                {row.name}
              </span>
              {['●', '●●', '●●●'].map(lvl => <span key={lvl} className="rounded-lg border border-plum-line bg-white/5 py-2 text-center text-[11px] tracking-widest text-white/70" data-id="element-244" data-mp="ldlhz8fw3ogt">
                  {lvl}
                </span>)}
            </div>)}
          <div className="grid grid-cols-[84px_1fr_1fr_1fr] gap-1.5 sm:grid-cols-[112px_1fr_1fr_1fr] text-[10px] font-semibold uppercase tracking-widest text-white/50" data-id="element-245" data-mp="2n2hi3wyezt4i">
            <span data-id="element-246" data-mp="2rypyfdoclsd9" />
            <span className="text-center" data-id="element-247" data-mp="3fq51j8ny8dpk">Start</span>
            <span className="text-center" data-id="element-248" data-mp="3frg2z1tx99di">Build</span>
            <span className="text-center" data-id="element-249" data-mp="3kpzsfc7q53am">Stretch</span>
          </div>
        </div>

        <ol className="mx-auto mt-8 grid max-w-3xl grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:items-center sm:justify-center sm:gap-3" data-id="element-250" data-mp="36q8h5j8le10b">
          {steps.map((step, i) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-251" data-mp="3aten0prslq69" data-mpi={i}>
              <span className="w-full whitespace-nowrap rounded-full bg-gold/15 px-3 py-2 text-[13px] font-semibold text-gold-hover sm:w-auto sm:px-4" data-id="element-252" data-mp="1v98im5vnipxu">
                <span className="mr-1.5 font-display" data-id="element-253" data-mp="2fk1janopck97">{i + 1}.</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className="hidden h-px w-5 bg-gold/50 sm:block" data-id="element-254" data-mp="2ari6vu1r3v5z" />}
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-255" data-mp="20unaphsya6uv">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-plum-line bg-white/5 px-4 py-3" data-id="element-256" data-mp="2yix9lnxfwehr">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-257" data-mp="2tk3whwm2epi4">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-258" data-mp="2kj5t9gjgam0l">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}